import { authHeader } from '../utils/authHeader';

import { API_BASE_URL } from '../config';

async function handle(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Ocurrió un error con los puntos');
  return data;
}

// Historial de movimientos de puntos Yale de un usuario (el propio usuario
// o un admin viendo el de otro).
export const getPointsHistory = async (userId) => {
  const res = await fetch(`${API_BASE_URL}/api/users/${userId}/points-history`, {
    headers: { ...authHeader() }
  });
  return handle(res);
};
